export const QUESTION_BANK_CREATION_LIMIT = 250;
